import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Registration from "./pages/Registration";
import Processing from "./pages/Processing";
import Result from "./pages/Result";
import AdminLogin from "./pages/AdminLogin";
import Dashboard from "./pages/Dashboard";
import AdminReferrers from "./pages/AdminReferrers";
import AdminCourses from "./pages/AdminCourses";
import RequireAdmin from "./components/RequireAdmin";
import NotFound from "./pages/NotFound";
import Receipt from "./pages/Receipt";
import AdminSiteSettings from "./pages/AdminSiteSettings";
import AdminCarousel from "./pages/AdminCarousel";
import AdminEvents from "./pages/AdminEvents";
import AdminFeedbacks from "./pages/AdminFeedbacks"; 
import AdminBroadcastNotification from "./pages/AdminBroadcastNotification";
import Colleges from "./pages/colleges";
import States from "./pages/States";
import Districts from "./pages/Districts";
import Taluks from "./pages/Taluks";
import AdminReceiptTitles from "./pages/AdminReceiptTitles";
import AdminReceiptSignatures from "./pages/AdminReceiptSignatures";
import AdminAboutUs from "./pages/AdminAboutUs";

 
export default function App() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<Home />} />
      <Route path="/register" element={<Registration />} />
      <Route path="/processing/:id" element={<Processing />} />
      <Route path="/result/:id" element={<Result />} />

      {/* Admin auth */}
      <Route path="/admin/login" element={<AdminLogin />} />

      {/* Protected admin routes */}
      <Route
        path="/dashboard"
        element={
          <RequireAdmin>
            <Dashboard />
          </RequireAdmin>
        }
      />

      <Route
        path="/admin/referrers"
        element={
          <RequireAdmin>
            <AdminReferrers />
          </RequireAdmin>
        }
      />

      <Route
        path="/admin/courses"
        element={
          <RequireAdmin>
            <AdminCourses />
          </RequireAdmin>
        }
      />

      <Route
        path="/admin/events"
        element={
          <RequireAdmin>
            <AdminEvents />
          </RequireAdmin>
        }
      />
            <Route
        path="/admin/colleges"
        element={
          <RequireAdmin>
            <Colleges />
          </RequireAdmin>
        }
      />
      <Route
  path="/admin/states"
  element={
    <RequireAdmin>
      <States />
    </RequireAdmin>
  }
/>
<Route
  path="/admin/districts"
  element={
    <RequireAdmin>
      <Districts />
    </RequireAdmin>
  }
/>
<Route
  path="/admin/taluks"
  element={
    <RequireAdmin>
      <Taluks />
    </RequireAdmin>
  }
/>
<Route
  path="/admin/aboutus"
  element={
    <RequireAdmin>
      <AdminAboutUs />
    </RequireAdmin>
  }
/>


<Route
  path="/admin/receipt-titles"
  element={
    <RequireAdmin>
      <AdminReceiptTitles />
    </RequireAdmin>
  }
/>

<Route
  path="/admin/receipt-signatures"
  element={
    <RequireAdmin>
      <AdminReceiptSignatures />
    </RequireAdmin>
  }
/>




      <Route
        path="/admin/feedback"          // 👈 matches Dashboard link
        element={
          <RequireAdmin>
            <AdminFeedbacks />
          </RequireAdmin>
        }
      />

      <Route
        path="/admin/settings"
        element={
          <RequireAdmin>
            <AdminSiteSettings />
          </RequireAdmin>
        }
      />

      <Route
        path="/admin/carousel"
        element={
          <RequireAdmin>
            <AdminCarousel />
          </RequireAdmin>
        }
      />
      <Route
  path="/admin/notifications"
  element={
    <RequireAdmin>
      <AdminBroadcastNotification />
    </RequireAdmin>
  }
/>


      {/* Receipt (public after payment) */}
      <Route path="/receipt/:id" element={<Receipt />} />

      {/* 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
